import { util } from 'echarts/core';
import { normalizeToArray } from '../../../util/utils';
import { type ThemeParser } from '../../../core/theme';
import { THS_FONTFAMILY_MEDIUM, FONT_SIZE_LIST } from '../static/font';

function parseXAxisPointer(...args: Parameters<ThemeParser>) {
  const [option, , optionToken] = args;
  const xAxisPointer1LabelFontSize = FONT_SIZE_LIST.axisPointerLabel;
  const xAxisPointer = {
    show: true,
    type: 'line',
    lineStyle: {
      color: 'rgba(133,133,133,1)',
      type: 'solid',
      width: 1
    },
    label: {
      show: false,
      fontFamily: THS_FONTFAMILY_MEDIUM,
      fontSize: xAxisPointer1LabelFontSize,
      color: '#fff',
      backgroundColor: 'rgba(51,102,255,1)'
    },
    snap: true
  };
  const xAxisArr = normalizeToArray(option.xAxis);
  xAxisArr.forEach(xAxis => {
    xAxis.axisPointer = util.merge(xAxis.axisPointer || {}, xAxisPointer);
  });
}

export function xAxisPointerThemeParse(...args: Parameters<ThemeParser>): ReturnType<ThemeParser> {
  // echarts没有到处value类型的坐标轴配置对象， 只能暂时用YAxisComponentOption替代一下

  parseXAxisPointer(...args);
}
